<template>
  <roe-modal
    wrap-class="popup-wrap"
    ref="popup"
    :close-on-click-outside="false"
  >
    <div class="popup-inner popup-inner--small" v-click-outside="close">
      <div class="popup-header">
        <h4>Plan Name</h4>
        <button class="btn-close" @click="close()"></button>
      </div>
      <div class="popup-content">
        <roe-error-message :field="$v.editableDesign.name">
          <input
            type="text"
            v-model="editableDesign.name"
            name="name"
            required
          />
        </roe-error-message>
        <div class="popup-actions">
          <button class="btn-primary" @click="save()">Save</button>
          <button class="btn-secondary" @click="close()">Cancel</button>
        </div>
      </div>
    </div>
  </roe-modal>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import { ALTERNATIVE_DESIGN_UPDATE } from "@/store/actions.type";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import RoeModal from "@/components/_shared/Modal";
export default {
  name: "RoeEditPlanDesignName",
  components: { RoeModal, RoeErrorMessage },
  data() {
    return {
      editableDesign: {}
    };
  },
  validations() {
    return {
      editableDesign: {
        name: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(20)
        }
      }
    };
  },
  methods: {
    save() {
      if (this.$v.$invalid) return;
      this.$store.dispatch(ALTERNATIVE_DESIGN_UPDATE, {
        design: this.editableDesign
      });
      this.close();
    },
    close() {
      this.$refs.popup.close();
      this.editableDesign = {};
    },
    open(design) {
      this.editableDesign = Object.assign({}, design);
      this.$refs.popup.open();
    }
  }
};
</script>
